import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { StateInfo } from '../../model/StateInfo.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;

  //Parameters from URL
  _ParamCycleCode: string;

  //State Model
  ListStatus: LookupInfo[] = [];
  ListStateManagement: StateInfo[] = [];
  StateInfo: StateInfo = new StateInfo;

  //Search
  isSearchSubmitted: boolean = false;
  txtSchStateName: string;
  txtSchStateCode: string;
  ddlSchStateStatus: string = "";

  //Form variable
  StateForm: FormGroup;
  IsDuplicateCode: boolean;

  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalState: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;


  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router, private activaterouter: ActivatedRoute) {
    this.baseurl = environment.base_api;
    //Set param
    this.activaterouter.params.subscribe(params => {
      this._ParamCycleCode = params['CycleCode'];
    });
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchStateStatus = 'Y'

    //Load init data
    this.LoadLookupType("StateSTATUS").then((data) => {
      this.ListStatus = data;
    });

    this.LoadStateList().then((data) => {
      this.ListStateManagement = data;
    });
    this.LoadCountStateList();

    //Declare form
    this.StateForm = new FormGroup({
      StateCode: new FormControl(this.StateInfo.StateCode, [Validators.required]),
      StateName: new FormControl(this.StateInfo.StateName, [Validators.required]),
    });
  }

  get StateCode() { return this.StateForm.get('StateCode'); }
  get StateName() { return this.StateForm.get('StateName'); }

  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadStateList(dataId: number = 0): Promise<StateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['StateCode'] = this.txtSchStateCode;
      objectjson['StateName'] = this.txtSchStateName;
      objectjson['CycleCode'] = this._ParamCycleCode;

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateInfo[]>(this.baseurl + "MasterSale/GetStateManagementList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountStateList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['StateCode'] = this.txtSchStateCode;
      objectjson['StateName'] = this.txtSchStateName;
      objectjson['CycleCode'] = this._ParamCycleCode;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "MasterSale/GetCountStateManagementList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadStateList().then((data) => {
      this.ListStateManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchStateCode = null;
    this.txtSchStateName = null;
    $('#ddlSchStateStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadStateList().then((data) => {
      this.ListStateManagement = data;
    });
  }

  //Create btn
  OnCreateState_Click() {

    $('#modalCreateStateTitle').html('Create State DOA');
    $('#modalCreateOrEditState').modal();
    this.StateInfo = new StateInfo;
    this.StateCode.setValue(null);
    this.StateName.setValue(null);

    this.StateForm.markAsUntouched();
    this.StateForm.markAsPristine();
  }

  async OnSubmitCreateState_Click() {
    if (this.StateForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.StateForm.value;
        objectjson['CycleCode'] = this._ParamCycleCode;
        objectjson['StateCode'] = this.StateForm.get('StateCode').value;
        objectjson['StateName'] = this.StateForm.get('StateName').value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/InsertStateManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'State has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditState').modal('hide');

            //Reload
            setTimeout(() => {
              this.LoadStateList().then((data) => {
                this.ListStateManagement = data;
              });
              this.LoadCountStateList();
            }, 300)  
            
          });
      }
    } else {
      this.markFormGroupTouched(this.StateForm);
    }

  }
  async OnEdit_Click(StateId) {

    if (!!StateId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadStateList(StateId).then((data) => {

          this.StateInfo = data[0];
          this.StateCode.setValue(data[0].StateCode);
          this.StateName.setValue(data[0].StateName);

          setTimeout(() => {

            $('#modalCreateStateTitle').html('Edit State DOA');
            $('#modalCreateOrEditState').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.StateForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.StateForm.value;
        objectjson['CycleCode'] = this._ParamCycleCode;
        objectjson['StateCode'] = this.StateForm.get('StateCode').value;
        objectjson['StateName'] = this.StateForm.get('StateName').value;


        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = this.StateInfo.Id;


        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/UpdateStateManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'State has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditState').modal('hide');

              //Reload
              this.LoadStateList().then((data) => {
                this.ListStateManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditState').modal('hide');

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.StateForm);
    }
  }
  async OnDelete_Click(StateId) {
    if (confirm("Are you sure you want to delete this state ?")) {
      if (!!StateId) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };

          var objectjson = this.StateForm.value;
          objectjson['CycleCode'] = this._ParamCycleCode;
          objectjson['UpdateBy'] = this._EmpCode;
          objectjson['Id'] = StateId;

          let arrjson: StateInfo[] = [];
          arrjson.push(objectjson);
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteStateManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {
                this.isSearchSubmitted = false;
                this.titlemodal = '';
                this.detailmodal = 'State has been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                //Reload
                this.LoadStateList().then((data) => {
                  this.ListStateManagement = data;
                });

              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    }
  }
  async OnDeleteList_Click() {
    var listDeleteChecked = $('[name="checkboxdelete"]:checked');
    let arrjson: StateInfo[] = [];
    var that = this;
    //เก็บ List id ที่จะ delete
    $.each(listDeleteChecked, function (idx, val) {
      var curId = $(val).data('positionid');
      var model = new StateInfo;
      model.Id = curId;
      model.CycleCode = that._ParamCycleCode;
      arrjson.push(model);
    });

    if (arrjson.length > 0) {
      if (confirm("Are you sure to delete these states?")) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //ส่งไป Delete
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteStateManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {

                this.titlemodal = '';
                this.detailmodal = 'States have been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                setTimeout(() => {
                  this.isSearchSubmitted = false;
                  //Reload
                  this.LoadStateList().then((data) => {
                    this.ListStateManagement = data;
                  });
                  this.LoadCountStateList()
                }, 500);


              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    } else {

      this.titlemodal = 'Fail.';
      this.detailmodal = 'Please select DOA to delete at lease 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }
  async OnMapping_Click(wfType, groupCode) {
    this.router.navigate(['/State-doa-mapping', { wf: wfType, groupcode: groupCode }])
  }

  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadStateList(positionId).then((data) => {

          this.StateInfo = data[0];
          this.StateCode.setValue(data[0].StateCode);
          this.StateName.setValue(data[0].StateName);

          setTimeout(() => {

            $('#modalCreateStateTitle').html('Edit State');
            $('#modalCreateOrEditState').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['StateCode'] = this.StateCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "MasterSale/CheckDuplicateStateManagementCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadStateList().then((data) => {
      this.ListStateManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalState = data;
    if (this.totalState == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalState / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
